import { render, staticRenderFns } from "./SendToPosButton.vue?vue&type=template&id=1563a49e&scoped=true"
import script from "./SendToPosButton.vue?vue&type=script&lang=js"
export * from "./SendToPosButton.vue?vue&type=script&lang=js"
import style0 from "./SendToPosButton.vue?vue&type=style&index=0&id=1563a49e&prod&lang=scss&scoped=true"
import style1 from "./SendToPosButton.vue?vue&type=style&index=1&id=1563a49e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1563a49e",
  null
  
)

export default component.exports